import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

type Option = {
    label: string;
    value: string;
};

type Props = {
    fieldName: string;
    label: string;
    options: Option[];
    placeholder?: string;
    disabled?: boolean;
};

const EditableSelectField = ({ fieldName, label, options, placeholder, disabled = false }: Props) => {
    return (
        <DetailWrapper>
            <DetailName>{label}</DetailName>
            <Field name={fieldName}>
                {({ field, meta }: any) => (
                    <>
                        <StyledSelect
                            {...field}
                            disabled={disabled}
                            hasError={meta.touched && meta.error}
                        >
                            <option value="">{placeholder || 'Select an option'}</option>
                            {options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </StyledSelect>
                        {meta.touched && meta.error && <ErrorText>{meta.error}</ErrorText>}
                    </>
                )}
            </Field>
        </DetailWrapper>
    );
};

const DetailWrapper = styled.div``;

const DetailName = styled.div`
    color: #008ac9;
    margin-bottom: 4px;
`;

const StyledSelect = styled.select<{ hasError?: boolean }>`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${props => props.hasError ? '#ff4d4f' : '#d9d9d9'};
    border-radius: 4px;
    font-size: 14px;
    color: #394372;
    background-color: ${props => props.disabled ? '#f5f5f5' : '#ffffff'};
    
    &:focus {
        outline: none;
        border-color: #008ac9;
        box-shadow: 0 0 0 2px rgba(0, 138, 201, 0.1);
    }
    
    &:disabled {
        cursor: not-allowed;
        color: #999;
    }
`;

const ErrorText = styled.div`
    color: #ff4d4f;
    font-size: 12px;
    margin-top: 4px;
`;

export default EditableSelectField;